import { useQuery } from '@tanstack/react-query';
import { portalApi } from '../services/portalApi';
import { queryKeys } from './queryKeys';
import { useApiMutation } from '../hooks/useApiMutation';

const useTemplateMutation = (opts) =>
  useApiMutation({ invalidate: [queryKeys.templates.all, queryKeys.messagingSettings.all], ...opts });

export function useTemplatesQuery() {
  return useQuery({
    queryKey: queryKeys.templates.list(),
    queryFn: () => portalApi.messageTemplates().then((r) => r.templates || []),
    staleTime: 5 * 60_000
  });
}

export function useCreateTemplate() {
  return useTemplateMutation({
    mutationFn: (values) => portalApi.createMessageTemplate(values),
    success: 'Template created',
    error: 'Could not create this template'
  });
}

export function useUpdateTemplate() {
  return useTemplateMutation({
    mutationFn: ({ _id, ...values }) => portalApi.updateMessageTemplate(_id, values),
    success: 'Template updated',
    error: 'Could not update this template'
  });
}

export function useDeleteTemplate() {
  return useTemplateMutation({
    mutationFn: (id) => portalApi.removeMessageTemplate(id),
    optimistic: (id) => [{ key: queryKeys.templates.list(), update: (list) => list.filter((t) => t._id !== id) }],
    success: 'Template deleted',
    error: 'Could not delete this template'
  });
}

export function useRecordTemplateUse() {
  return useTemplateMutation({ mutationFn: (id) => portalApi.useMessageTemplate(id) });
}
